import { gql } from "@apollo/client";
import Link from "next/link";
import { FC } from "react";

import Archive2OutlineIcon from "@src/lib/icons/18px/archive-2-outline";
import { SidebarMenuButton, SidebarMenuItem } from "@src/lib/ui/Sidebar";

import useMessagingActivityUnreadCount from "./useMessagingActivityUnreadCount";

const MessagingActivityNavItem: FC<{ active: boolean }> = ({ active }) => {
  const unreadCount = useMessagingActivityUnreadCount(false);

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        isActive={active}
        aria-current={active ? "page" : undefined}
        className="text-gray-11 [&>svg]:size-4"
      >
        <Link href="/newsfeed/activity" className="flex">
          <Archive2OutlineIcon />
          <span>Activity</span>
          {unreadCount > 0 && (
            <span className="ml-auto flex h-[15px] min-w-[22px] shrink-0 items-center justify-center rounded-full bg-brand px-1 text-[10px] leading-none font-semibold tracking-[-0.5px] text-white">
              {unreadCount}
            </span>
          )}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};

gql`
  query MessagingActivityUnreadCount($types: [MessagingActivityItemType!]) {
    MessagingActivityItems(
      filters: {
        read: false
        types: $types
        excludeHiddenFromNewsfeed: { value: true }
      }
    ) {
      totalCount
    }
  }
`;

export default MessagingActivityNavItem;
